export default __webpack_public_path__ + "static/media/transition_Liquid_Elements.b89ca798.png";